import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { deliveryTrackingService } from '../services/delivery-tracking.service';
import type { UpdateDeliveryStatusPayload } from '../types/delivery-tracking.types';

export function useUpdateDeliveryStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateDeliveryStatusPayload) =>
      deliveryTrackingService.updateDeliveryStatus(payload),
    onSuccess: (_, { orderId }) => {
      queryClient.invalidateQueries({ queryKey: ['order-delivery-tracking', orderId] });
      queryClient.invalidateQueries({ queryKey: ['order', orderId] });
      toast.success('Statut de livraison mis à jour');
    },
    onError: () => {
      toast.error('Erreur lors de la mise à jour du statut de livraison');
    },
  });
}
